<script>
  import { createEventDispatcher } from 'svelte';
  import { timerDot, timerLine, timerLetter, timerWord } from './stores.js';
  import MorseAudio from './MorseAudio.svelte'

  const dispatch = createEventDispatcher();

  export let sequence;
  let isPlaying = false;
	let isLightOn = false;
  let currentSign = '';
  const signTimer = 500;
  
  const timerRef = new Map();
  timerRef.set('.', $timerDot);    // -- dot timer
  timerRef.set('_', $timerLine);   // -- line timer
  timerRef.set('°', $timerLetter); // -- letter timer
  timerRef.set('|', $timerWord);   // -- Word timer

  lightMorseSequence();
  
  // -------------------------------------------------
  async function lightMorseSequence() {
    if (isPlaying) { return }
    isPlaying = true;
    await delay(1000);
    for (const sign of sequence) {
      const timer = timerRef.get(sign);
      currentSign = sign;
      // console.log(`timer: ${timer} | sign: ${sign}`);
      isLightOn = ['.', '_'].includes(sign);
      await delay(timer);
      if (isLightOn) {
        isLightOn = false;
        currentSign = '';
        await delay(signTimer);
      }
    }
    isLightOn = false;
    currentSign = '';
    isPlaying = false;
  }

	async function delay(duration) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(), duration);
    });
  }

  function closeLight(e) {
    e.preventDefault();
    isLightOn = false;
    dispatch('closeLight');
  }
</script>

<div>
  <div class="btn-section">
    <button class="{ isPlaying ? 'btn-disabled' : '' }" disabled={isPlaying}>
      <svg class="btn-svg" on:click="{ lightMorseSequence }" xmlns="http://www.w3.org/2000/svg" style="isolation:isolate" viewBox="0 0 512 512">
        <defs>
          <clipPath id="a">
            <path d="M0 0h512v512H0z"/>
          </clipPath>
        </defs>
        <g clip-path="url(#a)" fill="#FFF">
          <path d="M430.533 81.357c-96.428-96.322-252.673-96.265-349.03.128-96.357 96.392-96.357 252.638 0 349.03 96.357 96.393 252.602 96.45 349.03.128 96.309-96.512 96.309-252.774 0-349.286Zm-14.039 335.297c-88.713 88.713-232.545 88.713-321.258 0s-88.713-232.545 0-321.258 232.545-88.713 321.258 0 88.713 232.545 0 321.258Z"/>
          <path d="M164 374.588V137.412c0-17.398 12.232-24.461 27.3-15.761L294 180.944l102.7 59.294c15.067 8.699 15.067 22.825 0 31.524L294 331.056l-102.7 59.293c-15.068 8.7-27.3 1.637-27.3-15.761Zm16.32 3.252c-.07-.32-.13-.64-.18-.96-.09-.75-.14-1.5-.14-2.25V137.37c0-.75.05-1.5.14-2.25.05-.32.11-.64.18-.96 1 .32 1.96.75 2.87 1.28.04.02.07.05.11.07L286 194.8l102.7 59.29c.03.02.05.04.08.05.86.49 1.66 1.06 2.41 1.7.06.05.11.11.17.16-.06.05-.11.11-.17.16-.75.64-1.55 1.21-2.41 1.7-.03.01-.05.03-.08.05L286 317.2l-102.7 59.29c-.04.02-.07.05-.11.07-.91.53-1.87.96-2.87 1.28Z" fill-rule="evenodd"/>
        </g>
      </svg>
    </button>
    <div class="separator"></div>
    <button>
      <svg class="btn-svg" on:click="{ closeLight }" xmlns="http://www.w3.org/2000/svg" style="isolation:isolate" viewBox="0 0 512 512">
        <defs>
          <clipPath id="a">
            <path d="M0 0h512v512H0z"/>
          </clipPath>
        </defs>
        <g fill="#FFF" clip-path="url(#a)">
          <path d="M374.923 136.967a9.921 9.921 0 0 0-14.039 0L255.865 241.986 150.648 136.967a9.922 9.922 0 0 0-13.841 13.84l105.019 105.218-105.019 105.217a9.922 9.922 0 0 0 13.841 13.841l105.217-105.019 105.218 105.019a9.922 9.922 0 0 0 13.84-13.841L269.904 256.025l105.019-105.218a9.921 9.921 0 0 0 0-13.84Z"/>
          <path d="M430.533 81.357c-96.428-96.322-252.673-96.265-349.03.128-96.357 96.392-96.357 252.638 0 349.03 96.357 96.393 252.602 96.45 349.03.128 96.309-96.512 96.309-252.774 0-349.286Zm-14.039 335.297c-88.713 88.713-232.545 88.713-321.258 0s-88.713-232.545 0-321.258 232.545-88.713 321.258 0 88.713 232.545 0 321.258Z"/>
        </g>
      </svg>
    </button>
  </div>
  <div
    class="morse-light {isLightOn ? 'morse-on' : 'morse-off'}"
  >
    <p class="current-sign">{ currentSign }</p>
    <MorseAudio playSound="{ isLightOn }"/>
  </div>
</div>

<style>
button {
  background: transparent;
  /* border: 1px solid red; */
  border: none;
}

.btn-disabled {
  opacity: 0.3;
}
.btn-section {
  display: flex;
  position: absolute;
  width: 100%;
  justify-content: space-evenly;
  bottom: 0;
}

.separator {
  width: 12px;
}

.morse-light {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: flex-start;
}

.morse-on {
  background: var(--color-4);
}

.morse-off {
  background: black;
}

.current-sign {
  text-align: center;
  color: white;
}

.btn-svg {
  width: 50px;
  margin-top: 6px;
}
</style>
